const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://www.puntocassonetti.it';

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Punto Cassonetti srls",
  "description": "Produttori di cassonetti in PVC e controtelai termici 100% Made in Italy. Certificazione trasmittanza termica Usb=1 W/m2K. Produzione su misura in 48 ore lavorative.",
  "url": siteUrl,
  "logo": "https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/81e3031b4bcc562bb081a6ae4aa9af2c.png",
  "image": "https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/83eda28e70a22d23db9809c10277b4c2.jpeg",
  "telephone": "+390519981801",
  "email": "puntocassonetti@gmail.com",
  "vatID": "IT03935951206",
  "priceRange": "€€",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Via dei Lapidari, 15",
    "addressLocality": "Bologna",
    "postalCode": "40129",
    "addressRegion": "Emilia-Romagna",
    "addressCountry": "IT"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 44.5377,
    "longitude": 11.3465
  },
  "hasMap": "https://www.google.com/maps/place/Via+dei+Lapidari,+15,+40129+Bologna",
  "areaServed": [
    { "@type": "State", "name": "Emilia-Romagna" },
    { "@type": "State", "name": "Lombardia" },
    { "@type": "State", "name": "Veneto" }
  ],
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
      "opens": "08:00",
      "closes": "18:00"
    }
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "reviewCount": "500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": [
    {
      "@type": "Review",
      "author": { "@type": "Person", "name": "Davide Colombo" },
      "reviewBody": "Collaboro con Punto Cassonetti per la fornitura di cassonetti PVC in Lombardia. Tempi rispettati, qualità costante.",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
    },
    {
      "@type": "Review",
      "author": { "@type": "Person", "name": "Roberto Tessaro" },
      "reviewBody": "Il Termiko® ha rivoluzionato i nostri cantieri in Veneto. Zero sopralluoghi, installazione immediata.",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
    },
    {
      "@type": "Review",
      "author": { "@type": "Person", "name": "Gianluca Ferrari" },
      "reviewBody": "Controtelai termici di ottima fattura. La produzione in 48 ore ci permette di pianificare i lavori con precisione.",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
    }
  ],
  "knowsAbout": [
    "Cassonetti PVC",
    "Controtelai termici",
    "Termiko",
    "EVO 150",
    "Rehau",
    "Monoblocco tapparelle",
    "Isolamento termico",
    "Trasmittanza termica"
  ]
};

const productListSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Prodotti Punto Cassonetti",
  "description": "Gamma completa di cassonetti PVC e controtelai termici Made in Italy",
  "url": `${siteUrl}/#prodotti`,
  "numberOfItems": 4,
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "item": {
        "@type": "Product",
        "name": "Cassonetti in PVC",
        "description": "Cassonetti PVC su misura con certificazione Usb=1 W/m²K. Modelli EVO 150 e Rehau. Produzione in 48 ore lavorative per serramentisti in Lombardia, Veneto ed Emilia Romagna.",
        "brand": { "@type": "Brand", "name": "Punto Cassonetti" },
        "category": "Cassonetti PVC",
        "manufacturer": { "@type": "Organization", "name": "Punto Cassonetti srls" },
        "countryOfOrigin": "IT",
        "aggregateRating": { "@type": "AggregateRating", "ratingValue": "5", "reviewCount": "200" }
      }
    },
    {
      "@type": "ListItem",
      "position": 2,
      "item": {
        "@type": "Product",
        "name": "Controtelai per Finestre",
        "description": "Controtelai termici PVC per finestre e portefinestre. Eliminazione ponti termici, compatibili con PVC, alluminio e legno. Certificazione energetica inclusa.",
        "brand": { "@type": "Brand", "name": "Punto Cassonetti" },
        "category": "Controtelai termici",
        "manufacturer": { "@type": "Organization", "name": "Punto Cassonetti srls" },
        "countryOfOrigin": "IT"
      }
    },
    {
      "@type": "ListItem",
      "position": 3,
      "item": {
        "@type": "Product",
        "name": "Termiko® – Controtelaio Kit Universale",
        "description": "Controtelaio brevettato Termiko® in kit universale. Si adatta a tutti i fori finestra senza sopralluogo. Installazione rapida per serramentisti e montatori.",
        "brand": { "@type": "Brand", "name": "Termiko®" },
        "category": "Controtelai kit",
        "manufacturer": { "@type": "Organization", "name": "Punto Cassonetti srls" },
        "countryOfOrigin": "IT",
        "award": "Brevetto esclusivo"
      }
    },
    {
      "@type": "ListItem",
      "position": 4,
      "item": {
        "@type": "Product",
        "name": "Monoblocco per Tapparelle",
        "description": "Monoblocco integrato cassonetto + controtelaio in un unico prefabbricato. Zero ponti termici, installazione rapida. Ottimale per nuove costruzioni.",
        "brand": { "@type": "Brand", "name": "Punto Cassonetti" },
        "category": "Monoblocco tapparelle",
        "manufacturer": { "@type": "Organization", "name": "Punto Cassonetti srls" },
        "countryOfOrigin": "IT"
      }
    }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Quali sono i tempi di produzione e consegna dei cassonetti PVC?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Punto Cassonetti garantisce produzione su misura e consegna in 48 ore lavorative dall'ordine. Il servizio copre Lombardia, Veneto ed Emilia Romagna."
      }
    },
    {
      "@type": "Question",
      "name": "I cassonetti PVC hanno certificazione termica?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sì. Tutta la gamma di cassonetti e controtelai Punto Cassonetti è certificata con trasmittanza termica Usb=1 W/m²K. La documentazione tecnica è disponibile su richiesta per ogni cantiere."
      }
    },
    {
      "@type": "Question",
      "name": "Cos'è il Termiko® e come funziona?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Termiko® è il controtelaio in kit universale brevettato da Punto Cassonetti. Si adatta a qualsiasi foro finestra senza sopralluogo preventivo. Il kit viene spedito completo e può essere installato in poche ore da serramentisti e montatori."
      }
    },
    {
      "@type": "Question",
      "name": "Fornite solo a professionisti o anche a privati?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Punto Cassonetti serve esclusivamente professionisti: serramentisti, montatori e imprese edili operanti in Lombardia, Veneto ed Emilia Romagna."
      }
    },
    {
      "@type": "Question",
      "name": "Come si richiede un preventivo per cassonetti o controtelai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Il preventivo è gratuito. Puoi compilare il form online sul sito, chiamare lo 051 9981801 oppure contattarci via WhatsApp al +39 393 993 2439. Un tecnico risponde entro 48 ore lavorative con un preventivo personalizzato."
      }
    },
    {
      "@type": "Question",
      "name": "In quali regioni operate?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Operiamo in tutto il Nord Italia, con copertura principale in Lombardia (Milano, Brescia, Bergamo), Veneto (Verona, Padova, Venezia, Vicenza) ed Emilia Romagna (Bologna, Modena, Parma, Ferrara, Rimini)."
      }
    }
  ]
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": siteUrl
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Prodotti",
      "item": `${siteUrl}/#prodotti`
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "Preventivo",
      "item": `${siteUrl}/#form`
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Punto Cassonetti | Cassonetti PVC e Controtelai Termici",
  "description": "Cassonetti PVC e controtelai termici Made in Italy. Termiko® certificato Usb=1 W/m²K. Preventivo 48h per serramentisti in Lombardia, Veneto, Emilia Romagna.",
  "url": siteUrl,
  "inLanguage": "it-IT",
  "isPartOf": {
    "@type": "WebSite",
    "name": "Punto Cassonetti",
    "url": siteUrl
  },
  "about": {
    "@type": "LocalBusiness",
    "name": "Punto Cassonetti srls"
  },
  "dateModified": "2026-03-26"
};

export default function SeoHead() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(productListSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
    </>
  );
}
